import type { FC, ReactNode } from 'react'

import Image from 'next/image'

import { Button } from '@/components/generals/button'
import { Reveal } from '@/components/generals/reveal'
import { Marquee } from '@/components/generals/marquee'
import { SectionHeading } from '@/components/generals/section-heading'
import { team } from '@/constants/content'

export const Team: FC = (): ReactNode => {
    return (
        <section
            id='team'
            className='relative w-full overflow-hidden py-[120px] lg:py-[160px]'
        >
            <div className='mx-auto flex w-full max-w-[1200px] flex-col items-center px-6 md:px-8 lg:px-16'>
                <SectionHeading
                    eyebrow='Team'
                    segments={[
                        { text: 'Meet the' },
                        { text: 'incredible', serif: true },
                        { text: 'team.' }
                    ]}
                    subtitle='We pride ourselves of being the best of the best and our team encapsulates that.'
                >
                    <Reveal
                        y={18}
                        blur={8}
                        delay={0.15}
                        className='mt-3'
                    >
                        <Button href='/contact'>
                            Book a 15-min call
                        </Button>
                    </Reveal>
                </SectionHeading>
            </div>

            <Reveal
                y={28}
                blur={10}
                delay={0.1}
                className='mt-14 w-full lg:mt-20'
            >
                <Marquee
                    duration={88}
                    gap='24px'
                    reverse
                >
                    {[...team, ...team].map((member, index) => (
                        <article
                            key={`${member.name}-${index}`}
                            className='group relative h-[380px] w-[280px] overflow-hidden rounded-xl bg-surface-1 ring-1 ring-white/8 sm:h-[420px] sm:w-[320px]'
                        >
                            <Image
                                src={member.image}
                                alt={`Portrait of ${member.name}`}
                                fill
                                sizes='(max-width: 640px) 280px, 320px'
                                className='object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.44,0,0.56,1)] group-hover:scale-105'
                            />

                            <div
                                aria-hidden='true'
                                className='absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent'
                            />

                            <div className='absolute inset-x-0 bottom-0 flex flex-col gap-1 p-5'>
                                <h3 className='text-lg leading-none font-medium tracking-[-0.02em] text-white'>
                                    {member.name}
                                </h3>

                                <p className='text-sm leading-none tracking-[-0.02em] text-white/56'>
                                    {member.role}
                                </p>
                            </div>
                        </article>
                    ))}
                </Marquee>
            </Reveal>
        </section>
    )
}
